import getProductNearUser from '@services/menu/getProductNearUser';

import * as actions from '../actionTypes';
import getDeeplink from '../selectors/getDeepLink';

const fetchProductNearUser = ({ latitude, longitude }) => async (
  dispatch,
  getState,
  axios,
) => {
  const type = actions.FETCH_PRODUCT_NEAR_USER;
  const currentUrl = new URL(window.location.href);
  try {
    const state = getState();
    const { gtin, productName, path } = getDeeplink(state);

    dispatch({ type });

    const { success, data } = await getProductNearUser({
      axios,
      gtin,
      productName,
      latitude,
      longitude,
    });

    const { vendor, product } = data;
    const mustRedirect = Boolean(success && Object.values(data)?.length);

    if (!mustRedirect && !path.startsWith('/restaurantes/')) {
      throw new Error('Invalid redirection path.');
    }

    const urlPath = (mustRedirect ? `/${vendor.url}` : `/${path}`).replace(
      /^\/+/,
      '/',
    );

    const newUrl = new URL(
      `${currentUrl.origin}${urlPath}${
        mustRedirect
          ? `?${new URLSearchParams({
              menuSection: 'section_details',
              p: product.id,
            }).toString()}`
          : currentUrl.search
      }`,
    );

    newUrl.searchParams.append('from', 'reload');

    window.location.href = newUrl.toString();
    return null;
  } catch (error) {
    window.location.href = currentUrl.toString();
  }
  return null;
};

export default fetchProductNearUser;
